import { useState } from "react";
import mainlogo from "@/assets/mylistiq-logo-new.png";
import CallToActionFooter from "@/components/Footer";

const REVIEWS = [
    {
        id: 1,
        stars: 5,
        quote:
            "MyListIQ completely changed how I run property launches. The Property emails go out exactly when I want, and my agents always get them on time. I used to dread launch week — now it runs itself.",
        tags: ["property", "launches"],
        tagLabel: "Property launches · Launches",
        name: "Sarah R.",
        role: "Senior Listing Agent · San Diego, CA",
        initials: "SR",
        avatarBg: "#1A7F6E",
        featured: true,
    },
    {
        id: 2,
        stars: 5,
        quote:
            "For the price, I genuinely cannot believe what you get. Full launch scheduling, agent management, and professional templates — all in one place. Worth every dollar for a solo agent like me.",
        tags: ["value"],
        tagLabel: "Value for money",
        name: "James M.",
        role: "Independent Agent · Newton, GA",
        initials: "JM",
        avatarBg: "#C9913A",
    },
    // {
    //     id: 3,
    //     stars: 5,
    //     quote:
    //         "Had a question about scheduling a bulk Service send on a public holiday. Support got back to me in under 20 minutes with a clear answer. That kind of responsiveness is rare.",
    //     tags: ["support"],
    //     tagLabel: "Support",
    //     name: "Priya K.",
    //     role: "Property Manager · Brisbane",
    //     initials: "PK",
    //     avatarBg: "#3B5EA6",
    // },
    {
        id: 4,
        stars: 5,
        quote:
            "I launched 4 properties last month through MyListIQ. Every Property landed in the right agent's inbox at the right time. No chasing, no errors, no stress. My clients noticed the difference immediately.",
        tags: ["launches"],
        tagLabel: "Property launches",
        name: "David L.",
        role: "Real Estate Principal · Madison, KY",
        initials: "DL",
        avatarBg: "#6B4FA8",
    },
    {
        id: 5,
        stars: 5,
        quote:
            "The Service templates are stunning. My clients always comment that our marketing looks premium. I've tried other platforms but none come close to the quality you get here for this price.",
        tags: ["Services", "value"],
        tagLabel: "Service launches · Value",
        name: "Anika M.",
        role: "Buyer's Agent · Orange, NC",
        initials: "AM",
        avatarBg: "#1A7F6E",
    },
    {
        id: 6,
        stars: 5,
        quote:
            "Setting up my first launch was surprisingly easy. The onboarding walked me through everything step by step, and when I got stuck, the support team was genuinely helpful — not just sending me to an FAQ.",
        tags: ["support", "value"],
        tagLabel: "Support · Value",
        name: "Tom C.",
        role: "New Agent · Ramsey, MN",
        initials: "TC",
        avatarBg: "#A0522D",
    },
    // {
    //     id: 7,
    //     stars: 5,
    //     quote:
    //         "The ability to schedule different Properties for different agents in the same launch is a game changer. I target buyers agents with one version and property managers with another. No other tool does this so cleanly.",
    //     tags: ["launches", "Property launches"],
    //     tagLabel: "Launches · Property launches",
    //     name: "Rachel L.",
    //     role: "launch Director · Gold Coast",
    //     initials: "RL",
    //     avatarBg: "#0F2137",
    // },
    {
        id: 8,
        stars: 4,
        quote:
            "Switched from a much more expensive platform last year. The savings were significant and I genuinely didn't lose any functionality. If anything the launch scheduling here is better and more intuitive.",
        tags: ["value", "launches"],
        tagLabel: "Value · Launches",
        name: "Ben N.",
        role: "Agency Owner · Jackson, MO",
        initials: "BN",
        avatarBg: "#2E7D6E",
    },
    {
        id: 9,
        stars: 5,
        quote:
            "My Properties used to look like everyone else's. Now they look like a luxury agency produced them. The templates are polished and the scheduling means I'm never rushing at the last minute before a launch.",
        tags: ["Properties", "support"],
        tagLabel: "Property launches",
        name: "Olivia P.",
        role: "Luxury Property Specialist · Oklahoma, OK",
        initials: "OP",
        avatarBg: "#8B1A4A",
    },
    {
        id: 10,
        stars: 5,
        quote:
            "We run launches across 30+ agents weekly. MyListIQ handles it without breaking a sweat. The agent list management alone saves us hours of manual work each month. Couldn't go back now.",
        tags: ["support", "launches"],
        tagLabel: "Support · Launches",
        name: "Helen G.",
        role: "Operations Manager · Putnam, WV",
        initials: "HG",
        avatarBg: "#C9913A",
    },
    {
        id: 11,
        stars: 5,
        quote:
            "Three months in and I've already seen more enquiries per listing than I did all of last year. My marketing is sharper, my timing is better, and agents actually open my emails now.",
        tags: ["value", "Services"],
        tagLabel: "Value · Service launches",
        name: "Marcus K.",
        role: "Sales Agent · Windsor, VT",
        initials: "MK",
        avatarBg: "#1A5276",
    },
    {
        id: 12,
        stars: 5,
        quote:
            "I set up a 6-week drip launch for a new development launch and it ran flawlessly. Every Service hit on the right day, the right agents got the right message, and I didn't have to touch it once after setup.",
        tags: ["launches", "support"],
        tagLabel: "Property launches · Support",
        name: "Fiona W.",
        role: "Development Sales · Natrona, WY",
        initials: "FW",
        avatarBg: "#5D4037",
    },
];

const FILTERS = [
    { key: "all", label: "All reviews" },
    { key: "launches", label: "Property launches" },
    { key: "Services", label: "Service launches" },

    { key: "support", label: "Support" },
    // { key: "value", label: "Value for money" },
];

// Summary stats shown in the hero
const STATS = [
    { value: "12+", label: "Verified reviews" },
    { value: "4.9", label: "Average rating" },
    { value: "500+", label: "Active agents" },
];

function Stars({ count }) {
    return (
        <span className="flex gap-0.5">
            {Array.from({ length: 5 }).map((_, i) => (
                <span
                    key={i}
                    className={`text-base ${i < count ? "text-amber-400" : "text-gray-200"}`}
                >
                    ★
                </span>
            ))}
        </span>
    );
}

function Avatar({ initials, bg }) {
    return (
        <div
            className="w-10 h-10 rounded-full flex items-center justify-center text-white font-bold text-sm flex-shrink-0 ring-2 ring-white shadow-sm"
            style={{ backgroundColor: bg }}
        >
            {initials}
        </div>
    );
}

function ReviewCard({ review }) {
    return (
        <div
            className={`group relative flex flex-col h-full rounded-2xl border transition-all duration-200 hover:-translate-y-1 hover:shadow-lg ${review.featured
                ? "border-gray-100 bg-white"
                : "border-gray-100 bg-white hover:border-blue-100"
                }`}
        >
            {/* Top accent bar for featured */}
            {/* {review.featured && (
                <div className="absolute top-0 inset-x-0 h-0.5 rounded-t-2xl bg-gradient-to-r from-blue-500 to-indigo-500" />
            )} */}

            <div className="flex flex-col flex-1 p-6 gap-4">
                {/* Header row: stars + badge */}
                <div className="flex items-center justify-between">
                    <Stars count={review.stars} />
                    {review.featured && (
                        <span className="bg-blue-50 text-blue-600 text-[10px] font-bold uppercase tracking-wider px-2.5 py-1 rounded-full border border-blue-100">
                            Top review
                        </span>
                    )}
                </div>

                {/* Quote */}
                <p className="text-[14px] leading-relaxed text-gray-700 flex-1">
                    <span
                        className="font-serif text-2xl leading-none text-blue-400 mr-1 select-none"
                        style={{ verticalAlign: "-6px" }}
                    >
                        "
                    </span>
                    {review.quote}
                </p>

                {/* Tag */}
                <span className="self-start text-[10px] font-semibold uppercase tracking-widest text-blue-600 bg-blue-50 px-2.5 py-1 rounded-md border border-blue-100">
                    {review.tagLabel}
                </span>

                {/* Author */}
                <div className="flex items-center gap-3 pt-4 border-t border-gray-50">
                    <Avatar initials={review.initials} bg={review.avatarBg} />
                    <div className="min-w-0">
                        <p className="text-sm font-semibold text-gray-900 truncate">{review.name}</p>
                        <p className="text-xs text-gray-400 mt-0.5 truncate">{review.role}</p>
                        <p className="text-[11px] text-emerald-600 font-medium mt-0.5 flex items-center gap-1">
                            <svg className="w-3 h-3" fill="currentColor" viewBox="0 0 20 20">
                                <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                            </svg>
                            Verified user
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default function ReviewsPage() {
    const [active, setActive] = useState("all");

    const visible = REVIEWS.filter(
        (r) => active === "all" || r.tags.includes(active)
    );

    return (
        <div className="min-h-screen bg-gradient-to-b from-blue-50 to-white">
            <header className="sticky top-0 z-50 backdrop-blur-md bg-gradient-to-b from-blue-100/90 to-blue-50/90">
                <div className="mx-auto px-4 sm:px-6 lg:px-8">
                    <div className="flex h-16 items-center justify-between">
                        <div className="flex items-center cursor-pointer" onClick={() => window.location.assign('/')}>
                            <img src={mainlogo} alt="MyListIQ - Easy. Affordable. Smarter." className="h-12 w-auto" />
                        </div>


                        {/* <div className="flex items-center gap-6">
                            <div className="hidden md:flex items-center gap-6">
                                <a href="/" className="text-muted-foreground hover:text-primary transition-colors text-sm">Features</a>
                                <a href="/" className="text-muted-foreground hover:text-primary transition-colors text-sm">Pricing</a>
                                <a href="/about" className="text-muted-foreground hover:text-primary transition-colors text-sm">About</a>
                            </div>
                            <a
                                href={localStorage.getItem("access_token") ? "/dashboard" : "/signup"}
                                className="inline-flex items-center px-4 py-2 text-sm font-semibold bg-gradient-to-r from-blue-600 to-indigo-600 text-white rounded-lg shadow-md hover:shadow-xl"
                            >
                                {localStorage.getItem("access_token") ? "Dashboard" : "Sign Up"}
                            </a>
                        </div> */}
                    </div>
                </div>
            </header>
            {/* HERO */}
            <section className="py-20 lg:py-24">
                <div className="max-w-7xl mx-auto px-6 text-center space-y-6">

                    <span className="font-bold text-blue-600">
                        Easy. Affordable. <span className="text-red-600">Smarter.</span>
                    </span>


                    <h1 className="text-3xl sm:text-4xl lg:text-6xl font-bold tracking-tight mb-2 text-foreground">
                        What agents say about{" "}
                        <span className="bg-gradient-to-r from-blue-600 to-indigo-500 bg-clip-text text-transparent">
                            MyList<span className="text-red-600 ">IQ</span>
                        </span>
                    </h1>

                    <p className="text-base sm:text-lg text-muted-foreground max-w-xl mx-auto mb-10 leading-relaxed">
                        Real feedback from agents who use our platform every day to market their listings smarter.
                    </p>

                    {/* Stats row */}
                    <div className="mx-auto mt-8 w-full max-w-4xl">
                        <div className="bg-white border border-gray-200 rounded-2xl shadow-sm overflow-hidden">
                            <div className="grid grid-cols-1 sm:grid-cols-2">
                                <div className="flex flex-col items-center justify-center px-6 py-6">
                                    <p className="text-3xl sm:text-4xl font-extrabold text-slate-900 leading-none">4.9</p>
                                    <div className="flex items-center justify-center gap-2 h-6 my-2">
                                        {Array.from({ length: 5 }).map((_, i) => (
                                            <span key={i} className="text-amber-400 text-base leading-none">★</span>
                                        ))}
                                    </div>
                                    <p className="text-xs sm:text-sm font-semibold tracking-[2px] uppercase text-gray-500 mt-1">Overall rating</p>
                                </div>

                                {/* <div className="flex flex-col items-center justify-center px-6 py-6 border-t sm:border-t-0 sm:border-l border-gray-100">
                                    <p className="text-3xl sm:text-4xl font-extrabold text-slate-900 leading-none">1,200+</p>
                                    <div className="flex items-center justify-center gap-2 h-6 my-2">
                                        {Array.from({ length: 5 }).map((_, i) => (
                                            <span key={i} className="w-2 h-2 rounded-full bg-amber-400 inline-block" />
                                        ))}
                                    </div>
                                    <p className="text-xs sm:text-sm font-semibold tracking-[2px] uppercase text-gray-500 mt-1">Agents trust us</p>
                                </div> */}

                                <div className="flex flex-col items-center justify-center px-6 py-6 border-t sm:border-t-0 sm:border-l border-gray-100">
                                    <p className="text-3xl sm:text-4xl font-extrabold text-slate-900 leading-none ml-6">98%</p>
                                    <div className="flex items-center justify-center gap-2 h-6 my-2">
                                        {Array.from({ length: 5 }).map((_, i) => (
                                            <span key={i} className="text-amber-400 text-base leading-none">★</span>
                                        ))}
                                    </div>
                                    <p className="text-xs sm:text-sm font-semibold tracking-[2px] uppercase text-gray-500 mt-1">Would recommend</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* FILTERS */}
            <div className="bg-white border-b border-gray-100 sticky top-16 z-30">
                <div className="max-w-7xl mx-auto px-6 py-3 flex items-center gap-2 flex-wrap">
                    <span className="text-[10px] font-bold text-gray-400 uppercase tracking-widest mr-2 hidden sm:block">
                        Filter
                    </span>
                    {FILTERS.map((f) => (
                        <button
                            key={f.key}
                            onClick={() => setActive(f.key)}
                            className={`text-xs font-semibold px-4 py-1.5 rounded-full border transition-all duration-150 ${active === f.key
                                ? "bg-blue-600 border-blue-600 text-white shadow-sm"
                                : "bg-white border-gray-200 text-gray-600 hover:border-blue-300 hover:text-blue-600"
                                }`}
                        >
                            {f.label}
                        </button>
                    ))}
                    <span className="ml-auto text-xs text-gray-400 font-medium hidden sm:block">
                        {visible.length} review{visible.length !== 1 ? "s" : ""}
                    </span>
                </div>
            </div>

            {/* REVIEWS GRID */}
            <section className="max-w-7xl mx-auto px-6 py-10 pb-20">
                <div className="flex items-center justify-between mb-6 flex-wrap gap-2">
                    <h2 className="text-base font-semibold text-slate-700">
                        Customer reviews
                        <span className="ml-2 text-xs font-semibold bg-blue-50 text-blue-600 px-2.5 py-0.5 rounded-full border border-blue-100 align-middle">
                            {visible.length}
                        </span>
                    </h2>
                </div>

                {visible.length === 0 ? (
                    <div className="text-center py-24">
                        <p className="text-gray-400 text-sm">No reviews match this filter.</p>
                    </div>
                ) : (
                    <div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
                        {visible.map((r) => (
                            <ReviewCard key={r.id} review={r} />
                        ))}
                    </div>
                )}
            </section>

            {/* <CallToActionFooter /> */}
        </div>
    );
}